import { MouseEventHandler, PropsWithChildren } from 'react';
import { twMerge } from 'tailwind-merge';
import { Link } from '@packages/common-ui/components/link';
import styles from './cta.module.css';
export interface PrimaryCtaProps {
  containerClassName?: string;
  className?: string;
  theme?: 'purple' | 'black';
  href?: string;
  disabled?: boolean;
  onClick?: MouseEventHandler<HTMLButtonElement>;
}
export const PrimaryCta = ({
  containerClassName = '',
  className = '',
  theme = 'purple',
  href,
  disabled = false,
  onClick,
  children
}: PropsWithChildren<PrimaryCtaProps>) => {
  const isButton = href === undefined;
  const isButtonDisabled = disabled && isButton;
  const borderClassNames = twMerge('w-fit inline-block rounded-2xl border border-gray-dark p-2', isButtonDisabled ? 'cursor-not-allowed' : 'cursor-pointer', containerClassName);
  const content = <span className={twMerge('primary-cta inline-block rounded-2xl border-0.5 border-solid px-10 py-3 text-xs font-bold uppercase leading-3 tracking-wider', theme === 'purple' ? styles.primary_cta_purple : styles.primary_cta_black, isButtonDisabled ? 'pointer-events-none opacity-50' : '', className)}>
      {children}
    </span>;
  return isButton ? <button className={borderClassNames} type="button" onClick={onClick} disabled={disabled}>
      {content}
    </button> : <Link className={borderClassNames} href={href}>
      {content}
    </Link>;
};